import React from 'react';
import './styles/Footer.css';

const Footer = () =>
  <div className="footer">
    <p>The best <span>Train Composition Viewer</span> you have ever seen</p>
  </div>

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js